<template>
    <div class="fleet-thresholds__view">
        <threshold-settings></threshold-settings>
    </div>
</template>

<script>

import ThresholdSettings from '@/views/_components/ThresholdSettings'

export default {
    name: 'VehiclesList',
    components: {
        ThresholdSettings
    },
    props: {
        uuid: {
            type: String
        }
    },
    data () {
        return {
        }
    }
}
</script>

<style scoped lang="scss">
.vehicle-table {
    margin-bottom: 30px;

    .v-btn {
        &.margin-right {
            margin-right: 10px !important;
        }
    }
}

</style>
